import { Button } from "components/Button"
import { Card, CardContent } from "components/Card"
import { useConnectedUser } from "components/ConnectedUserProvider"
import { Page } from "components/Page"
import { useRouter } from "components/Router"
import { Text } from "components/Text"
import { useTranslator } from "components/Translator"
import { Wrapper } from "components/Wrapper"
import { Image } from "components/Image"
import * as User from "domains/user/model"

export function ClubGiftShowPage({ gift }) {
  const connectedUser = useConnectedUser()
  const router = useRouter()
  const translator = useTranslator()

  return (
    <Page padded>
      <Wrapper>
        <div className="space-y-6">
          <div>
            <Text variant="headline2" tag="h1">
              {gift.title}
            </Text>
            <Text variant="subtitle2">{gift.subtitle}</Text>
          </div>
          <div className="flex flex-col space-y-6 md:flex-row md:space-y-0 md:space-x-8">
            <div className="md:w-52 lg:w-64 md:shrink-0">
              <Card spacing="small">
                <CardContent>
                  <div className="h-48">
                    <Image
                      imageFile={gift.imageFile}
                      size="w640"
                      alt=""
                      className="w-full h-full object-contain object-center"
                    />
                  </div>
                </CardContent>
              </Card>
            </div>
            <div className="space-y-6">
              <Text tag="div">
                <p
                  dangerouslySetInnerHTML={{
                    __html: gift.description,
                  }}
                />
              </Text>
              {!connectedUser || !User.isClub(connectedUser) ? (
                <Button
                  href={router.generate("app_club_shop_plan_index")}
                  variant="outline"
                  color="secondary"
                >
                  {translator.trans("club.gift.show.clubCTA", null, "pages")}
                </Button>
              ) : null}
            </div>
          </div>
        </div>
      </Wrapper>
    </Page>
  )
}
